import { useAuthContext } from "src/auth/AuthContext";
import TransfersForm from "./TransfersForm";
import { useParams } from "react-router-dom";

const TransfersView = () => {
  const { user } = useAuthContext();
  const { id } = useParams();
  return (
    <TransfersForm
      transferId={parseInt(id ?? "-1")}
      organizationId={user?.data?.organizationId}
      onSubmit={(_ps) => Promise.resolve()}
      viewOnly={true}
      header="Ansicht"
    />
  );
};

export default TransfersView;
